import { combineReducers } from 'redux';

import {
  setOpenAudioInstructionModal,
  setAudioInstructionId,
  setInlineAudioInstruction,
} from '../../actions';
import { ScriptEditorAction, AudioInstructionState } from '../../types';
import { Reducer } from '../../../../types';
import audios from './audios';

type ReducerOf<T extends keyof AudioInstructionState> = Reducer<AudioInstructionState, ScriptEditorAction, T>;

const isOpenModal: ReducerOf<'isOpenModal'> = (state = false, action) => {
  switch (action.type) {
    case setOpenAudioInstructionModal.type:
      return action.payload;

    default:
      return state;
  }
};

const instructionId: ReducerOf<'instructionId'> = (state = '', action) => {
  switch (action.type) {
    case setAudioInstructionId.type:
      return action.payload;

    default:
      return state;
  }
};
const isInline: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineAudioInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  isOpenModal,
  isInline,
  instructionId,
  audios,
});
